<script>
import FuzzySearchbox from 'fuzzy-searchbox'

import { mapGetters } from "vuex"

import store from '@/store'

import uniqby from 'lodash.uniqby'

export default {
    data() {
        return {
            school: '',
            teacher: ''
        }
    },
    mounted () {
       
    },
    components: {
        FuzzySearchbox
    },
    computed: {
        ...mapGetters({
            role: 'getUserRole',
            id: 'getEmployeeId',
            currentPage: 'getCurrentPage',
            firstName: 'getFirstName',
            schools: 'admin/getSchools',
            selectedSchool: 'admin/getSelectedSchool'
        }),
        teachers () {
            const teachers = this.selectedSchool.teachers
            return teachers.sort((a,b) => {
                if (a.LastName < b.LastName) {
                    return -1;
                }
                if (a.LastName > b.LastName) {
                    return 1;
                }
                return 0;
            })
        }
    },
    methods: {
        uniqListOfSchools (schools) {
            return uniqby(schools, 'SchoolDBN')
        },
        uniqListOfTeachers (teachers) {
            return uniqby(teachers, 'EmployeeID')
        },
        displayStringForSchool (s) {
            return `${s.dbn || s.SchoolDBN} - ${s.name || s.SchoolDBN_Name}`
        },
        displayStringForTeacher (s) {
            return `${s.FirstName} ${s.LastName}`
        }
    },
    watch: {
        school: async function(n, o) {
            await store.dispatch('admin/fetchSelectedSchool', {dbn: n.SchoolDBN})
            this.$router.push({path: '/school-dashboard'})
        },
        teacher: function(n) {
            this.$router.push({path: `/observations/${n.EmployeeID}`})
        }
    }
}
</script>

<template>
    <nav>
        <div class="logo">
            <img src="../assets/images/tiny-ge-logo.png" alt="">
        </div>
        <ul 
            v-if="role === 'Teacher'"
            class="menu"
        >
            <li :class="{active: currentPage === 'teacher-dashboard'}">
                <router-link :to="{name: 'home'}">
                    <p>Dashboard</p>
                </router-link>
            </li>
            <li
                :class="{active: currentPage === 'observations'}"
            >
                <router-link :to="{name: 'teacher-observations'}">
                    <p>Observations</p>
                </router-link>
            </li>
            <li
                :class="{active: currentPage === 'goalSetting'}"
            >
                <router-link :to="{path: '/goalSetting/teacher'}">
                    <p>Professional Goal Setting</p>
                </router-link>
            </li>
            <li 
                :class="{active: currentPage === 'weTeach'}"
            >
                <router-link :to="{name: 'weteach'}">
                    <p>WeTeachNYC</p>
                </router-link>
            </li>
        </ul>
        <ul 
            v-else
            class="menu"
        >
            <li 
                v-if="['Superintendent', 'Executive Superintendent', 'Central', 'Field Staff'].indexOf(role) !== -1"
                :class="{active: currentPage === 'district'}"
            >
                <router-link to="/district-dashboard">
                    <p>District</p>
                </router-link>
            </li>
            <li 
                :class="{active: currentPage === 'school'}"
                class="hoverable"
            >
                <router-link 
                    v-if="['Principal', 'Assistant Principal'].indexOf(role) >= 0"
                    :to="{name: 'home'}"
                >
                    <p>School</p>
                </router-link>
                <div 
                    v-else
                    class="nav-container"
                >
                    <p>
                        School
                    </p>
                    <div class="nav-container-search">
                        <FuzzySearchbox
                            id="select-school"
                            v-model="school"
                            aria-label="select a school"
                            placeholder="select a school"
                            :item-keys="['SchoolDBN_Name', 'SchoolDBN']"
                            :create-label-function="displayStringForSchool" 
                            :items="uniqListOfSchools(schools)"
                        />
                    </div>
                </div>
            </li>
            <li 
                :class="{active: currentPage === 'teacher' || currentPage === 'observations' }"
                class="hoverable"
            >
                <div
                    :class="{inactive: ['school', 'teacher-dashboard', 'observations'].indexOf(currentPage) == -1 && ['Principal', 'Assistant Principal', 'School Based Staff'].indexOf(role) === -1}" 
                    class="nav-container"
                >
                    <p>Teacher</p>
                     <div
                        v-if="['school', 'teacher-dashboard', 'observations'].indexOf(currentPage) >= 0 || ['Principal', 'Assistant Principal', 'School Based Staff'].indexOf(role) >= 0" 
                        class="nav-container-search"
                     >
                        <FuzzySearchbox
                            id="select-teacher"
                            v-model="teacher"
                            aria-label="select a teacher"
                            placeholder="select a teacher"
                            :item-keys="['FirstName', 'LastName']"
                            :create-label-function="displayStringForTeacher" 
                            :items="uniqListOfTeachers(teachers)"
                        />
                     </div>
                </div>
            </li>
            <li 
                v-if="['Principal', 'Assistant Principal'].indexOf(role) !== -1"
                :class="{active: currentPage === 'goalSetting'}"
            >
                <router-link :to="{path: '/goalSetting/admin'}">
                    <p>Professional Goal Setting</p>
                </router-link>
            </li>
            <li :class="{active: currentPage === 'weTeach'}">
                <router-link :to="{name: 'weteach'}">
                    <p>WeTeachNYC</p>
                </router-link>
            </li>
        </ul>
        <div class="login">
            <p>Welcome, {{ firstName }}</p>
            <a href="/auth/sso/doe_sso.php?logout">Sign Off</a>
        </div>
    </nav>
</template>

<style lang="scss" scoped>
    * {
        font-family: Arial;
    }
    nav {
        display: flex;
        align-items: center;
        padding: 1em 1em 0 1em;
        border-bottom: 1px solid #000000;
        .menu {
            display: flex;
            justify-content: space-around;
            width: 70%;
            margin: 0;
            padding: 0;
            list-style-type: none;
            a {
                text-decoration: none;
            }
        }
        .menu li {
            font-size: 1.2em;
            padding: 15px 25px 5px 25px;
            border-bottom: 10px solid transparent;
            cursor: pointer;
        }
        .menu li.active {
            border-bottom: 10px solid #2c557d;
        }
        .menu li:hover {
            background-color: #2c557d;
            p {
                color: #ffffff;
            }
        }
        .menu li.hoverable:hover {
            .nav-container-search {
                display: block;
            }
        }
        .menu li p {
            font-size: 1.3em;
            margin: 0;
        }
        .logo, .login {
            width: 15%;
        }
        .logo {
            img {
                width: 100%;
            }
        }
        .login {
            padding: 0 0 0 10px;
            p {
                margin: 0;
                font-weight: bold;
                font-size: 1.2em;
            }
            a {
                color: #000;
                text-decoration: none;
            }
        }
        .inactive {
            p {
                color: #ccc;
            }
        }
    }
    .nav-container {
        position: relative;
        .nav-container-search {
            display: none;
            position: absolute;
            height: 30px;
            padding: 10px;
            bottom: -67px;
            left: -25px;
            background-color: #fff;
            border: 1px solid #000;
        }
    }
    ::v-deep #select-school, ::v-deep #select-teacher {
        input {
            width: 250px;
            padding: 5px;
        }
        .autocomplete-results {
            max-height: 200px;
            li {
                font-size: 14px;
            }
            .is-active {
                background-color: #769D4E;
            }
        }
    }
</style>